import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PartnerService from 'tio-employee/services/partner';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type EmployeeModel from 'tio-data/models/employee';
import type CompanyModel from 'tio-data/models/company';

export default class AuthenticatedAdminEmployeesAddRoute extends Route {
  @service declare partner: PartnerService;
  @service declare store: StoreService;

  async model() {
    const employee = this.store.createRecord<EmployeeModel>('employee', {});
    // @ts-expect-error this is a known thing until we fix models
    const company = await this.store.findRecord<CompanyModel>('company', this.partner.company.id, {
      include: 'company-setting,plans',
    });
    employee.company = company;
    return employee;
  }
}
